/**
 * Store for `detect.UAParse`
 * @module
 */

var _ = require('optimizely-client-fn');
var actionTypes = require('../constants/action_types');

module.exports = {
  initialize: function() {
    this.__state = {} as any;
    this.on(actionTypes.SET_UA_DATA, this.__loadData);
  },

  /**
   * Initializes useragent data
   * @private
   * @param {UserAgentData} payload.ua
   */
  __loadData: function(payload) {
    if (!_.isEmpty(this.__state)) {
      return;
    }

    this.__state = payload.data;
  },

  /**
   * Returns the user agent data
   * @return {UserAgentData}
   */
  get: function(): UserAgentData {
    return _.cloneDeep(this.__state);
  },
};

